import React from 'react';
import { useSelector } from 'react-redux';
import { BoxWrapper } from './CommonPurchase.styles';
import {
  ActionRow,
  DetailGrid,
  DetailItem,
  DocChip,
  DocChips,
  InfoBoxGrid,
  InfoCard,
  InfoCardHeader,
  InfoCardTitle,
  PrimaryActionButton,
  PrimaryActionLink,
  SectionLabel,
  StatusPill,
} from './InfoBoxV2.styles';
import ProductsTableCard from './ProductsTableCard';
import { getDDFDocument, guideType, primaQuoteTypes } from '../../../../constants';
// import MessagesModal from '../../../elements/MessagesModal';
import { apiDownloadDocument } from '../../../../../services/axios-client/axeCommons';
import axe from '../../../../../services/axios-client/axiosClient';
import { downloadFile } from '../../../../../services/axios-client/axeHelpers';
import { isNewBrokerageSystem } from '../../../../helpers/brokerageHelpers';

function InfoBoxMoto({
  insuranceRequest,
  statues,
  quoteStatus,
  // messagesModalData,
  rc_quotation,
  risk_quotations,
}) {
  const { quoteTypes } = useSelector((store) => store.utilities.quoteTypes);

  const DDF_document = getDDFDocument(rc_quotation, insuranceRequest);

  const downloadDocument = async (documentId) => {
    if (documentId === undefined) {
      return;
    }
    const response = await apiDownloadDocument(documentId);
    const alink = document.createElement('a');
    alink.target = '_blank';
    alink.href = response.data.data.contents;
    alink.download = response.data.data.filename;
    alink.click();
  };

  const downloadResourceDocs = async (id) => {
    const res = await axe.get(`/download-resource-document/${id}/0`, {
      responseType: 'blob',
    });

    downloadFile(res.data);
  };

  const getTotal = () => {
    let primaGuaranteesPrices = 0;
    let risksTotalAmount = 0;
    // let servicePrice = 0;

    // if (
    //   insuranceRequest.insurance_request_extra_services.length > 0
    // ) {
    //   insuranceRequest.insurance_request_extra_services.forEach((service) => {
    //     servicePrice += parseFloat(calculateExtraServicePrice(rc_quotation, service));
    //   });
    // }

    if (risk_quotations && risk_quotations.length > 0) {
      for (let i = 0; i < risk_quotations.length; i++) {
        const item = risk_quotations[i];

        // risksTotalAmount += rc_quotation.payment_frequency === 1 ? parseFloat(item.amount) : parseFloat(item.amount / rc_quotation.payment_frequency);
        risksTotalAmount += parseFloat(item.amount);
      }
    }

    if (rc_quotation.company_id === 2) {
      rc_quotation.guarantees.forEach((guarantee) => {
        // primaGuaranteesPrices += rc_quotation.payment_frequency === 1 ? parseFloat(guarantee.amount) : parseFloat(guarantee.amount / rc_quotation.payment_frequency) || 0;
        primaGuaranteesPrices += parseFloat(guarantee.amount);
      });
    }

    // const rcTotalAmount = rc_quotation.payment_frequency === 1 ? rc_quotation.amount : rc_quotation.amount / rc_quotation.payment_frequency;
    const rcTotalAmount = rc_quotation.amount;

    // return parseFloat(rcTotalAmount + primaGuaranteesPrices + servicePrice (rc_quotation.amount_paid !== null && !isNewBrokerageSystem(rc_quotation) ? 0 : getBrokeragePerPayment(rc_quotation)) + risksTotalAmount).toFixed(2);
    return parseFloat(rcTotalAmount + primaGuaranteesPrices + rc_quotation.brokerage_amount + risksTotalAmount).toFixed(2);
  };

  const downloadPreventive = async () => {
    const res = await axe.get(
      `/quotations/${rc_quotation.id}/preventivo/generate`,
      {
        responseType: 'blob',
      },
    );

    downloadFile(res.data);
  };

  return (
    <>
      <BoxWrapper>
        <InfoBoxGrid>
          <InfoCard>
            <InfoCardHeader>
              <InfoCardTitle>Riepilogo</InfoCardTitle>
              <StatusPill>{statues.find((st) => st.id === quoteStatus).name}</StatusPill>
            </InfoCardHeader>
            <DetailGrid>
              <DetailItem className="full">
                <dt>Cliente</dt>
                <dd>
                  {insuranceRequest.customer.gender !== 'G'
                    ? `${insuranceRequest.customer.name
                    } ${insuranceRequest.customer.surname}`
                    : insuranceRequest.customer.business_name}
                </dd>
              </DetailItem>
              <DetailItem className="full">
                <dt>Veicolo</dt>
                <dd>{insuranceRequest.moto.version.full_description}</dd>
              </DetailItem>
              <DetailItem>
                <dt>Targa</dt>
                <dd>{insuranceRequest.moto.moto_plate}</dd>
              </DetailItem>
              <DetailItem>
                <dt>Decorrenza</dt>
                <dd>
                  {new Date(
                    insuranceRequest.policy_effective_date,
                  ).toLocaleDateString('it-IT')}
                </dd>
              </DetailItem>
              <DetailItem>
                <dt>Tipo Di Guida</dt>
                <dd>{guideType.find((v) => v.id === insuranceRequest.guide_type).name}</dd>
              </DetailItem>
              <DetailItem>
                <dt>Frequenza Pagamento</dt>
                <dd>{rc_quotation.payment_frequency === 1 ? 'Annuale' : 'Semestrale'}</dd>
              </DetailItem>
            </DetailGrid>

            <SectionLabel>Documenti</SectionLabel>
            <DocChips>
              {rc_quotation.company_id === 9 && rc_quotation.product_id === 2 && (
                <DocChip
                  type="button"
                  onClick={() => downloadResourceDocs(
                    21,
                    0,
                  )}
                >
                  Informazioni Precontrattuali RC Moto
                </DocChip>
              )}
              {rc_quotation.company_id === 2 && rc_quotation.product_id === 2 && (
                <DocChip
                  type="button"
                  onClick={() => {
                    let id = 22;

                    if (rc_quotation.quotation_data_prima && rc_quotation.quotation_data_prima.issuing_company === 'triglav') {
                      id = 36;
                    }

                    if (rc_quotation.quotation_data_prima && rc_quotation.quotation_data_prima.issuing_company === 'great_lakes') {
                      id = 33;
                    }

                    downloadResourceDocs(
                      id,
                      0,
                    );
                  }}
                >
                  Informazioni Precontrattuali RC Moto
                </DocChip>
              )}
              {rc_quotation.company_id === 18 && rc_quotation.product_id === 2 && (
                <DocChip
                  type="button"
                  onClick={() => downloadResourceDocs(
                    28,
                    0,
                  )}
                >
                  Informazioni Precontrattuali RC Moto
                </DocChip>
              )}
              <DocChip type="button" onClick={() => downloadPreventive()}>
                Preventivo
              </DocChip>
            </DocChips>

            <ActionRow>
              {rc_quotation.link_to_endpoint && (
                <PrimaryActionLink
                  href={rc_quotation.link_to_endpoint}
                  target="_blank"
                  rel="noreferrer"
                >
                  Paga Ora
                </PrimaryActionLink>
              )}
              <PrimaryActionButton
                type="button"
                onClick={() => downloadDocument(DDF_document.id)}
              >
                Scarica Documento Da Firmare
              </PrimaryActionButton>
            </ActionRow>
          </InfoCard>

          <ProductsTableCard total={getTotal()}>
            <tr>
              <td>{rc_quotation.product.name}</td>
              <td>
                {rc_quotation.company_id !== null ? rc_quotation.company.name : rc_quotation.preventivas_company.company_name}
              </td>
              <td>
                {/* {rc_quotation.payment_frequency === 1 ? parseFloat(rc_quotation.amount - rc_quotation.issuance_fee - (rc_quotation.is_facile_quote === 1 ? 20.9 : 0)).toFixed(2) : parseFloat((rc_quotation.amount - rc_quotation.issuance_fee - (rc_quotation.is_facile_quote === 1 ? 20.9 : 0)) / rc_quotation.payment_frequency).toFixed(2)} */}
                {parseFloat(rc_quotation.amount - rc_quotation.issuance_fee - (rc_quotation.is_facile_quote === 1 ? 20.9 : 0)).toFixed(2)}
                {' '}
                &euro;
              </td>
            </tr>
            {(rc_quotation !== null && rc_quotation.company_id === 2) && (
              rc_quotation.guarantees.map((guarantee, index) => (
                <tr key={index}>
                  <td>{primaQuoteTypes.find((type) => type.id === guarantee.guarantees_slug).name}</td>
                  <td>
                    Prima.it
                  </td>
                  <td>
                    {' '}
                    {/* {rc_quotation.payment_frequency === 1 ? parseFloat(guarantee.amount).toFixed(2) : parseFloat(guarantee.amount / rc_quotation.payment_frequency).toFixed(2)} */}
                    {parseFloat(guarantee.amount).toFixed(2)}
                    {' '}
                    €
                  </td>
                </tr>
              ))
            )}
            {risk_quotations
              && risk_quotations.map((quote, index) => (
                <tr key={index}>
                  <td>
                    {
                      quoteTypes.find(
                        (type) => type.id === quote.quote_type,
                      ).name
                    }
                  </td>
                  <td>{quote.company.name}</td>
                  <td>
                    {/* {rc_quotation.payment_frequency === 1 ? parseFloat(quote.amount).toFixed(2) : parseFloat(quote.amount / rc_quotation.payment_frequency).toFixed(2)} */}
                    {parseFloat(quote.amount).toFixed(2)}
                    {' '}
                    &euro;
                  </td>
                </tr>
              ))}
            <tr>
              <td>
                Brokeraggio
                {rc_quotation.amount_paid !== null && !isNewBrokerageSystem(rc_quotation) && <span className="text-success fw-bold"> (Pagato)</span>}
              </td>
              <td />
              <td>
                {/* {parseFloat(getBrokeragePerPayment(rc_quotation)).toFixed(2)} */}
                {parseFloat(rc_quotation.brokerage_amount).toFixed(2)}

                {' '}
                &euro;
              </td>
            </tr>
            <tr>
              <td>Spese Di Emissione</td>
              <td />
              <td>
                {/* {rc_quotation.payment_frequency === 1
                  ? parseFloat(parseFloat(rc_quotation.issuance_fee) + (rc_quotation.is_facile_quote === 1 ? 20.9 : 0)).toFixed(2)
                  : parseFloat(
                    (parseFloat(rc_quotation.issuance_fee) + (rc_quotation.is_facile_quote === 1 ? 20.9 : 0))
                    / rc_quotation.payment_frequency,
                  ).toFixed(2)} */}
                {parseFloat(parseFloat(rc_quotation.issuance_fee) + (rc_quotation.is_facile_quote === 1 ? 20.9 : 0)).toFixed(2)}
                {' '}
                &euro;
              </td>
            </tr>
            {/* {insuranceRequest.insurance_request_extra_services && insuranceRequest.insurance_request_extra_services.length > 0
              && insuranceRequest.insurance_request_extra_services.map((service, index) => (
                <tr key={index}>
                  <td>Servizio Assistenza Stradale</td>
                  <td />
                  <td>
                    {rc_quotation.payment_frequency === 1
                      ? 'Annuale'
                      : 'Semestrale'}
                  </td>
                  <td>
                    {calculateExtraServicePrice(rc_quotation, service)}
                    &euro;
                  </td>
                </tr>
              ))} */}
          </ProductsTableCard>
          {/* <hr />
          <ContactBox
            as="button"
            data-bs-toggle="modal"
            data-bs-target="#messages-modal"
          >
            <img src={contactSupport} alt="Conttato Suporto" />
            {insuranceRequest.threads.length > 0 && insuranceRequest.threads[0].messages.filter((mes) => mes.read_by_broker === 0).length > 0 ? <MessageNumber>{insuranceRequest.threads[0].messages.filter((mes) => mes.read_by_broker === 0).length}</MessageNumber> : ''}
            <h5>{insuranceRequest.threads.length > 0 ? 'Apri Chat' : 'Apri Nuova Chat'}</h5>
          </ContactBox> */}
        </InfoBoxGrid>
      </BoxWrapper>
      {/* <MessagesModal
        {...messagesModalData}
        threads={insuranceRequest.threads}
      /> */}
    </>
  );
}

export default InfoBoxMoto;
